import firebase from 'firebase/compat/app';

import { FirebaseTimestamp } from '@/models';

import 'firebase/compat/firestore';

export function convertDate(timestamp: FirebaseTimestamp | { seconds: number; nanoseconds: number } | string): string {
  let dateObject: Date;

  if (typeof timestamp === 'string') {
    // ISO string like "2025-04-14T12:56:02.493Z"
    dateObject = new Date(timestamp);
  } else if ('seconds' in timestamp && 'nanoseconds' in timestamp) {
    // If it's not a Firestore Timestamp instance, reconstruct it
    const firestoreTimestamp =
      timestamp instanceof firebase.firestore.Timestamp
        ? timestamp
        : new firebase.firestore.Timestamp(timestamp.seconds, timestamp.nanoseconds);

    dateObject = firestoreTimestamp.toDate();
  } else {
    throw new Error('Unsupported timestamp format');
  }

  return new Intl.DateTimeFormat('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  }).format(dateObject);
}
